import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PublicDownloadIssuedLetterService {

  private http:HttpClient
  constructor(private handler: HttpBackend) { 
      this.http = new HttpClient(handler);
    }

  public generateLetter(appId, paylaod,acronym):Observable<any>{
    return this.http.post(environment.BASE_URL_DES+`${acronym}Public/generateLetter/`+appId,paylaod)
  }

  public generateApplicantLetter(appId, acronym,isFinal):Observable<any>{
    return this.http.get(environment.BASE_URL_DES+`${acronym}/generateApplicantLetter/${appId}/${isFinal}`)
  }

  public generateBody(payload,appId):Observable<any>{
    return this.http.post(environment.BASE_URL_DAS+`desfPublic/getLetterBody/${appId}`,payload)
  }

  public updateLetter(payload,appId):Observable<any>{
    return this.http.post(environment.BASE_URL_DAS+`desfPublic/generateLetter/${appId}`,payload)
  }
}
